// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper---cl0ZH","content":"content---_QgqY"};